(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3BadgeList', {
            templateUrl: 'app/home/badge-list/badge-list.component.html',
            controller: BadgeListComponent,
            bindings: {
                memberBadges: '<badges'
            }
        });

    BadgeListComponent.$inject = ['badgeDefinitions', 'urlBuilder', 'noopUrl', 'tweetUrl', 'facebookUrl', 'gettextCatalog', 'Member', 'user', 'alert', 'home_resources'];
    function BadgeListComponent(badgeDefinitions, urlBuilder, noopUrl, tweetUrl, facebookUrl, gettextCatalog, Member, user, alert, resources) {
        // Variables
        var ctrl = this,
            now = new Date(),
            year = now.getFullYear();

        // Properties
        ctrl.isCurrent = true;
        ctrl.year = year;
        ctrl.yearList = [year, year - 1, year - 2, null];

        // Methods
        ctrl.$onInit = init;
        ctrl.socialPost = socialPost;
        ctrl.getString = gettextCatalog.getString.bind(gettextCatalog);
        ctrl.yearChange = yearChange;
        //////////////////////////////////////////

        function init() {
            ctrl.badges = Object.entries(badgeDefinitions).map(Badge);
        }

        function socialPost(event, badge) {
            if (badge.earned)
                event.stopPropagation();
        }

        function yearChange() {
            Member.getBadges({ id: user.id, year: ctrl.year }, success, error, true);

            function success(badges) {
                ctrl.memberBadges = badges;
            }
            function error() {
                alert.error(resources.badgesRequestFailed);
            }
        }

        //////////////////////////////////////////
        function Badge(entry) {
            if (!(this instanceof Badge))
                return new Badge(entry)
            this._key = entry[0];
            this._data = entry[1];
        }

        Object.defineProperties(Badge.prototype, {
            definition: {get: getDefinition },
            earned: { get: getEarned },

            imageUrl: { get: getImageUrl },
            title: { get: getTitle },
            description: { get: getDescription },
            facebookUrl: { get: getFacebookUrl },
            twitterUrl: { get: getTwitterUrl },
        });

        function getDefinition(){
            return badgeDefinitions[this._key];
        }

        function getEarned() {
            return ctrl.memberBadges[this._key];
        }

        function getImageUrl() {
            return this.earned ? this.definition.image : this.definition.imageGray;
        }

        function getTitle() {
            return this.definition.title;
        }

        function getDescription() {
            return this.earned ? this.definition.earned : this.definition.unearned;
        }

        function getFacebookUrl() {
            return this.earned ? urlBuilder(facebookUrl, { text: this.definition.facebook }) : noopUrl;
        }

        function getTwitterUrl() {
            return this.earned ? urlBuilder(tweetUrl, { text: this.definition.twitter }) : noopUrl;
        }
    }
})();